import { render, staticRenderFns } from "./printPurchaseApply.vue?vue&type=template&id=5b964160&scoped=true"
import script from "./printPurchaseApply.vue?vue&type=script&lang=js"
export * from "./printPurchaseApply.vue?vue&type=script&lang=js"
import style0 from "./printPurchaseApply.vue?vue&type=style&index=0&id=5b964160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b964160",
  null
  
)

export default component.exports